/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Master17Inputs */

const en__field_enum_csjensblank_master17 = /** @type {(inputs: _Field_Enum_Csjensblank_Master17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master`)
};

const de__field_enum_csjensblank_master17 = /** @type {(inputs: _Field_Enum_Csjensblank_Master17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master`)
};

/**
* | output |
* | --- |
* | "Master" |
*
* @param {_Field_Enum_Csjensblank_Master17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_master17 = /** @type {((inputs?: _Field_Enum_Csjensblank_Master17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Master17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_master17(inputs)
	return de__field_enum_csjensblank_master17(inputs)
});
export { _field_enum_csjensblank_master17 as "_field_enum_CSJENSBLANK_MASTER" }